module.exports = __webpack_public_path__ + "img/settings.850605d0.svg";